/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialBenefits200,
  GetApiV1CoursefinancialBenefits401,
  GetApiV1CoursefinancialBenefits500,
  GetApiV1CoursefinancialBenefitsQueryResponse,
} from "../../types/courseFinancialSharedController/GetApiV1CoursefinancialBenefits.ts";
import { benefitOptionViewModelSchema } from "../benefitOptionViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialBenefits200Schema = z.array(
  z.lazy(() => benefitOptionViewModelSchema),
) as unknown as ToZod<GetApiV1CoursefinancialBenefits200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialBenefits401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialBenefits401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialBenefits500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialBenefits500>;

export const getApiV1CoursefinancialBenefitsQueryResponseSchema = z.lazy(
  () => getApiV1CoursefinancialBenefits200Schema,
) as unknown as ToZod<GetApiV1CoursefinancialBenefitsQueryResponse>;
